import React from "react";
import Navbaartesting from "../../components/Navbaartesting";
import Footer from "../../components/Footer";

const AdmissionProcessPolicies = () => {
  return <div>Admission Process and Policies</div>;
};

export default AdmissionProcessPolicies;
